
/* -------------------------------------------------------------------------- */
/*                                 step wizard                                */
/* -------------------------------------------------------------------------- */ 

const registrationFormInit = () => {

  /*-----------------------------------------------
  |   Custom values for forms
  -----------------------------------------------*/ 

  var listGenders = ["Female", "Male", "Other"];
  var listGendersValues = ["Female", "Male", "Unknown"];

  var listCounties = ["Out of State", "Anderson", "Andrews", "Angelina", "Aransas", "Archer", "Armstrong", "Atascosa", "Austin", "Bailey", "Bandera", "Bastrop", "Baylor", "Bee", "Bell", "Bexar", "Blanco", "Borden", "Bosque", "Bowie", "Brazoria", "Brazos", "Brewster", "Briscoe", "Brooks", "Brown", "Burleson", "Burnet", "Caldwell", "Calhoun", "Callahan", "Cameron", "Camp", "Carson", "Cass", "Castro", "Chambers", "Cherokee", "Childress", "Clay", "Cochran", "Coke", "Coleman", "Collin", "Collingsworth", "Colorado", "Comal", "Comanche", "Concho", "Cooke", "Coryell", "Cottle", "Crane", "Crockett", "Crosby", "Culberson", "Dallam", "Dallas", "Dawson", "Deaf Smith", "Delta", "Denton", "DeWitt", "Dickens", "Dimmit", "Donley", "Duval", "Eastland", "Ector", "Edwards", "El Paso", "Ellis", "Erath", "Falls", "Fannin", "Fayette", "Fisher", "Floyd", "Foard", "Fort Bend", "Franklin", "Freestone", "Frio", "Gaines", "Galveston", "Garza", "Gillespie", "Glasscock", "Goliad", "Gonzales", "Gray", "Grayson", "Gregg", "Grimes", "Guadalupe", "Hale", "Hall", "Hamilton", "Hansford", "Hardeman", "Hardin", "Harris", "Harrison", "Hartley", "Haskell", "Hays", "Hemphill", "Henderson", "Hidalgo", "Hill", "Hockley", "Hood", "Hopkins", "Houston", "Howard", "Hudspeth", "Hunt", "Hutchinson", "Irion", "Jack", "Jackson", "Jasper", "Jeff Davis", "Jefferson", "Jim Hogg", "Jim Wells", "Johnson", "Jones", "Karnes", "Kaufman", "Kendall", "Kenedy", "Kent", "Kerr", "Kimble", "King", "Kinney", "Kleberg", "Knox", "La Salle", "Lamar", "Lamb", "Lampasas", "Lavaca", "Lee", "Leon", "Liberty", "Limestone", "Lipscomb", "Live Oak", "Llano", "Loving", "Lubbock", "Lynn", "Madison", "Marion", "Martin", "Mason", "Matagorda", "Maverick", "McCulloch", "McLennan", "McMullen", "Medina", "Menard", "Midland", "Milam", "Mills", "Mitchell", "Montague", "Montgomery", "Moore", "Morris", "Motley", "Nacogdoches", "Navarro", "Newton", "Nolan", "Nueces", "Ochiltree", "Oldham", "Orange", "Palo Pinto", "Panola", "Parker", "Parmer", "Pecos", "Polk", "Potter", "Presidio", "Rains", "Randall", "Reagan", "Real", "Red River", "Reeves", "Refugio", "Roberts", "Robertson", "Rockwall", "Runnels", "Rusk", "Sabine", "San Augustine", "San Jacinto", "San Patricio", "San Saba", "Schleicher", "Scurry", "Shackelford", "Shelby", "Sherman", "Smith", "Somervell", "Starr", "Stephens", "Sterling", "Stonewall", "Sutton", "Swisher", "Tarrant", "Taylor", "Terrell", "Terry", "Throckmorton", "Titus", "Tom Green", "Travis", "Trinity", "Tyler", "Upshur", "Upton", "Uvalde", "Val Verde", "Van Zandt", "Victoria", "Walker", "Waller", "Ward", "Washington", "Webb", "Wharton", "Wheeler", "Wichita", "Wilbarger", "Willacy", "Williamson", "Wilson", "Winkler", "Wise", "Wood", "Yoakum", "Young", "Zapata", "Zavala"];

  var checkboxQuestions = [];
  checkboxQuestions.push("1. I certify that I am at least 18 years of age.");
  checkboxQuestions.push("2. I hereby give my consent to Lone Star Family Health Center and the healthcare professional administering the vaccine today.");
  checkboxQuestions.push("3. I understand that the Moderna COVID-19 vaccine requires two doses and that I should receive a second dose of the same vaccine 24 to 28 days later to complete the vaccination series.");
  checkboxQuestions.push("4. I understand that it is not possible to predict all possible side effects or complications associated with receiving the vaccine. I have received and read the Emergency Use Authorization for the vaccination I wish to receive.");
  checkboxQuestions.push("5. I agree to remain present for at least 15 minutes after vaccination to be monitored.");
  checkboxQuestions.push("6. I hereby consent to the administration of the COVID-19 vaccine. Furthermore, I hereby release and forever discharge for myself, my heirs, executors, administrators and assignees, Lone Star Family Health Center and their employees, owners and representatives, from any and all claims, demands, actions and causes of action, which may result from participation in this program.");
  checkboxQuestions.push("7. I acknowledge that: (a) I understand the purposes/benefits of my state’s vaccination registry (“Immtrac2”) and (b) the applicable Provider may disclose my vaccination information to the State Registry, for purposes of public health reporting, or to my healthcare providers enrolled in the State Registry for purposes of care coordination.");
  checkboxQuestions.push("8. I will communicate the information provided to me today about my vaccination to my primary care provider if I have one.");
  checkboxQuestions.push("9. The Notice of Patient Privacy Practices and the Patient Rights and Responsibilities are posted on our website at www.lonestarfamily.org for patients to review. I accept that services may be rendered in a non-private setting. I have read and understand all of the above.");

  /*-----------------------------------------------
  |   Patient Name
  -----------------------------------------------*/

  var lastName = "Smith";
  var firstName = "John";
  var middleName = "Quincy";

  /*-----------------------------------------------
  |   Dates and times for appointments
  -----------------------------------------------*/

  var availableDates = [];
  availableDates.push("May 3, 2021");
  availableDates.push("May 7, 2021");
  availableDates.push("May 24, 2021");

  var availableTimes = [];
  availableTimes.push(["9:00AM", "11:00AM"]);
  availableTimes.push(["10:00AM", "11:00AM", "2:00PM"]);
  availableTimes.push(["11:00AM", "1:00PM", "2:00PM", "3:00PM"]);

  /*-----------------------------------------------
  |   Helper Functions
  -----------------------------------------------*/

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
  
  /*-----------------------------------------------
  |   Defining content in registration form
  -----------------------------------------------*/

  var allNameBlocks = document.getElementsByClassName("name-block");
  for (var a=0; a<allNameBlocks.length; a+=1) {
    allNameBlocks[a].innerHTML =  "<label class=\"col-form-label\">Name:&emsp;</label>" +
                                  "<label class=\"col-form-label static-name\">" + lastName + ",&nbsp;</label>" +
                                  "<label class=\"col-form-label static-name\">" + firstName + "&nbsp;</label>" +
                                  "<label class=\"col-form-label static-name\">" + middleName + "</label>";
  }

  // Set max date to 18 years before today

  const dateOfBirth = document.getElementById("date-of-birth"); 
  // var today = new Date();
  dateOfBirth.setAttribute("data-date-end-date","0d");
  
  // dateOfBirth.data-options = maxDate;

  // Define genders
  const genders = document.getElementById("gender");
  let fillGenders = "<option value=\"\">Select...</option>";
  if (listGenders.length === listGendersValues.length) {
    for (var g=0; g<listGenders.length; g+=1) {
      fillGenders += "<option value=\"" + listGendersValues[g] + "\">" + listGenders[g] + "</option>";
    }
    genders.innerHTML = fillGenders;
  }

  // Add counties to registration if desired
  var city = document.getElementById("city-div");
  let counties = document.createElement("div");
  counties.className = "mb-3 col-sm-4 counties";
  var fillCounties = "<select class=\"form-select\" id=\"county\" required>" +
                      "<option value=\"\">County</option>";
  for (var b=0; b<listCounties.length; b+=1) {
    fillCounties += "<option value=\"" + listCounties[b] + "\">" + listCounties[b] + "</option>";
  }
  fillCounties += "</select>";
  counties.innerHTML = fillCounties;
  insertAfter(city, counties);

  // Check for previous vaccine
  const vaccineYes = document.getElementById("vaccine_yes");
  const vaccineNo = document.getElementById("vaccine_no");
  const nextVaccineQuestion = document.getElementById("next_vaccine_question");

  const buttonNext = document.getElementById ("submit");

  vaccineYes.onclick = function() {
    nextVaccineQuestion.innerHTML = 
      "<label class=\"form-label\" for=\"vaccine-manufacturer\">Vaccine Manufacturer</label>" +
      "<select class=\"form-select mb-3\" name=\"manufacturer\" id=\"vaccine-manufacturer\" required>" +
        "<option value=\"\">Select...</option>" +
        "<option value=\"Johnson\">Johnson & Johnson</option>" +
        "<option value=\"Moderna\">Moderna</option>" +
        "<option value=\"Pfizer\">Pfizer</option>" +
      "</select>" +
      "<div class=\"form-label error-message\" id=\"johnson\"></div>" +
      "<label class=\"form-label\" for=\"date-first-vaccine\">Date of 1st Vaccine</label>" +
      "<input class=\"form-control datetimepicker mb-3\" id=\"date-first-vaccine\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-options='{\"disableMobile\":true, \"dateFormat\":\"m/d/Y\"}' required />" +
      "<label class=\"form-label\" for=\"location-first-vaccine\">Healthcare Professional or Clinic Site where received</label>" +
      "<input class=\"form-control mb-3\" type=\"text\" id=\"location-first-vaccine\" placeholder=\"Facility Name\" required>";
    const manufacturer = document.getElementById("vaccine-manufacturer");
    const johnson = document.getElementById("johnson");
    manufacturer.addEventListener("change", function() {
      if (this.value === "Johnson") {
        johnson.innerHTML = "Johnson & Johnson requires only one vaccine dose. You do not need to register for any additional vaccines at this time."
        buttonNext.disabled = true;
      } else {
        johnson.innerHTML = "";
        buttonNext.disabled = false;
      }
    });
  }

  vaccineNo.onclick = function() {
    nextVaccineQuestion.innerHTML = "";
  }

  // Get insurance information
  const insuranceYes = document.getElementById("insurance_yes");
  const insuranceNo = document.getElementById("insurance_no");
  const nextInsuranceQuestion = document.getElementById("next_insurance_question");

  insuranceYes.onclick = function() {
    nextInsuranceQuestion.innerHTML = 
      "<div class=\"row\">" +
        "<label class=\"form-label\">Subscriber Name</label>" +
        "<div class=\"col-sm-6\">" +
          "<input class=\"form-control mb-3\" type=\"text\" id=\"subscriber_first_name\" placeholder=\"First Name\" pattern=\"[A-za-z -]+\" required/>" +
        "</div>" +
        "<div class=\"col-sm-6\">" +
          "<input class=\"form-control mb-3\" type=\"text\" id=\"subscriber_last_name\" placeholder=\"Last Name\" pattern=\"[A-za-z -]+\" required/>" +
        "</div>" +
      "</div>" +
      "<label class=\"form-label\" for=\"dropdown-relationship\">Relationship to Subscriber</label>" +
      "<select class=\"form-select mb-3\" name=\"relationship\" id=\"dropdown-relationship\" required>" +
        "<option value=\"\">Select...</option>" +
        "<option value=\"Self\">Self</option>" +
        "<option value=\"Spouse\">Spouse</option>" +
        "<option value=\"Child\">Child</option>" +
        "<option value=\"Other\">Other</option>" +
      "</select>" +
      "<label class=\"form-label\" for=\"subscriber-date-of-birth\">Subscriber Date of Birth</label>" +
      "<input class=\"form-control datetimepicker mb-3\" id=\"subscriber-date-of-birth\" type=\"text\" placeholder=\"mm/dd/yyyy\" data-options='{\"disableMobile\":true, \"dateFormat\":\"m/d/Y\"}' required />" +
      "<label class=\"form-label\">Insurance Provider</label>" +
      "<input class=\"form-control mb-3\" type=\"text\" id=\"insurance_provider\" pattern=\"[A-za-z -.]+\" required/>" +
      "<label class=\"form-label\">Member ID</label>" +
      "<input class=\"form-control mb-3\" type=\"text\" id=\"member_id\" pattern=\"[A-za-z0-9 -]+\" required/>" +
      "<label class=\"form-label\">Group Number</label>" +
      "<input class=\"form-control mb-3\" type=\"text\" id=\"group_number\" pattern=\"[0-9 -]+\" required/>"
    ;
  };

  insuranceNo.onclick = function() {
    nextInsuranceQuestion.innerHTML = 
      "<label class=\"form-label\">Social Security No.</label><input class=\"form-control mb-3\" type=\"text\" id=\"ssn\" placeholder=\"xxx-xx-xxxx\" pattern=\"[0-9]{3}-[0-9]{2}-[0-9]{4}\" required/>";
  };

  const customQuestions = document.getElementById("custom_questions");

  var numQuestions = checkboxQuestions.length;
  customQuestions.innerHTML = "";
  var questionString = "";
  for (var i=0; i < numQuestions; i+=1) {
    var currentCondition = "condition_" + i.toString() ;
    questionString += "<div class=\"form-check\">" +
                          "<input class=\"form-check-input\" type=\"checkbox\" name=\"terms\" id=\"" +
                          currentCondition +
                          "\" required>" +
                          "<label class=\"form-check-label\" for=\"" +
                          currentCondition +
                          "\">" +
                          checkboxQuestions[i] +
                          "</label>" +
                        "</div>\n";
  }
  customQuestions.innerHTML = questionString;

  const appointmentDates = document.getElementById("dropdown-appointment-date");
  appointmentDates.innerHTML = "<option value=\"\">Select a date...</option>";
  for (var j=0; j<availableDates.length; j+=1) {
    appointmentDates.innerHTML += "<option value=" + j.toString() + ">" + availableDates[j] + "</option>";
  }

  const appointmentTimes = document.getElementById("appointment-times");

  function setAppointmentTimes(dateIndex) { 
    var currTimes = availableTimes[parseInt(dateIndex, 10)];
    appointmentTimes.innerHTML = "";
    for (var i=0; i<currTimes.length; i+=1) {
      appointmentTimes.innerHTML += ("<div class=\"btn btn-outline-primary\" role=\"button\">" +
                                    "<input type=\"radio\" name=\"time-options\" value=\"time" + i.toString() +
                                    "\" autocomplete=\"off\" required=\"required\">" + currTimes[i].toString() + "<div class=\"invalid-feedback\" style=\"position: absolute; top: 0.25em; left: 10.0em; width:20.0em\">Please select an appointment time</div></div>");
    }
  }

  setAppointmentTimes(0);
  
  appointmentDates.addEventListener("change", function() {
    setAppointmentTimes(this.value);
  });
  
};

export default registrationFormInit;
